import { ref } from 'vue';

export const useDrawer = () => {
  const isVisible = ref(false);

  const show = (): void => {
    isVisible.value = true;
  };
  const hide = (): void => {
    isVisible.value = false;
  };
  const toggle = (): void => {
    isVisible.value = !isVisible.value;
  };
  const handleVisibilityChange = (value: boolean): void => {
    if (!value) {
      isVisible.value = false;
    }
  };

  return {
    isVisible,
    show,
    hide,
    toggle,
    handleVisibilityChange,
  };
};
